import { IUserInfo } from "./services/user";

export default function (initialState: { userInfo: IUserInfo }) {
  /** 创建机器人页面权限 */
  const canReadCreateRobotPage = !!initialState?.userInfo?.enableCreateRobot;
  return {
    canReadCreateRobotPage,
  };
}
